import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const forgotPassword = async (email: string): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "post",
      `/auth/forgot-password`,
      { data: { email } }
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to send reset email");
  }
};
